import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Tabs,
  Chip,
  Tab,
  Typography,
  IconButton,
  FormControl,
  MenuItem,
  Select,
  Grid,
  InputLabel,
} from "@mui/material";
import DashboardContent from "../dashboard";
import ReportsTicketsDashboardContent from "../reports-tickets-dashboard";

import { withSnackbar } from "../../utils/common/SnackbarHoc";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import LowPriorityIcon from "@mui/icons-material/LowPriority";
import images from "../../global-styles/images";
import EmailReply from "./EmailReply";
import { useParams } from "react-router-dom";
import {
  getStatusRenderLabel,
  getpageType,
  getpageTypeEmail,
  getpageTypeForEmail,
  renderStatusColorCss,
} from "../../utils/common/common";
import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";
import { Http, appLogger } from "../../utils";
import TicketDetails from "./TicketDetails";
import { put } from "../../utils/http";
import { enableMailReply } from "../../utils/config";
interface TabPanelProps {
  children?: any;
  index: number;
  value: number;
  className: any;
}
function TabPanel(props: TabPanelProps) {
  const { children, value, index, className, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      className={className}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const TicketsDetailsReply = (props: any) => {
  // window.onload = () => {
  //   setValue(0);
  // };
  // let defaultActiveTab = 0;
  const { pagetype, ticketId } = useParams();
  // const getUrl = window.location.href;
  // if (getUrl.includes("tickets-reply")) {
  //   defaultActiveTab = 1;
  // }
  const [loader, setLoader] = useState(false);
  const [priotyUpdateLoader, setPriotyUpdateLoader] = useState(false);

  const { userInfo } = useContext(UserContext) as UserLoginInfo;
  const [feedbackDetails, setFeedbackDetails] = useState<any>();
  const [StatusValue, setStatusValue] = useState<any>("");
  const getLocation: any = useLocation();
  const navigate = useNavigate();
  const messages: any = [];
  function a11yProps(index: number, label: any) {
    messages.push(label);
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  let productDetails: any = "";
  if (getLocation && getLocation.state && getLocation.state.productDetails) {
    productDetails = getLocation.state.productDetails;
  }
  let tabType = "";
  if (getLocation && getLocation.state && getLocation.state.tabType) {
    tabType = getLocation.state.tabType;
  }
  let defaultActiveTab = 0;
  if (tabType != "") {
    defaultActiveTab = 1;
  }
  useEffect(() => {
    setValue(defaultActiveTab);
  }, [tabType]);

  useEffect(() => {
    Http.post({
      url: `/api/v2/marknotification/${ticketId}`,
      state: userInfo,
    })
      .then((response: any) => {})
      .catch((error: any) => {});
  }, []);

  const [value, setValue] = useState(defaultActiveTab);
  const [selectedPriority, setselectedPriority] = useState("");
  const [subjectVal, setSubject] = useState("");
  const [EnablingEmailTab, setEnablingEmailTab] = useState<any>(false);
  const handleChange = (event: any, newValue: number) => {
    setValue(newValue);
    setLoader(false);
  };

  const fetchFeedbackDetails = async () => {
    setLoader(true);
    try {
      const feddbackData: any = await Http.get({
        url: `/api/v2/userFeedback?id=${ticketId}`,
        state: userInfo,
      });
      setLoader(false);
      appLogger.info({
        infoObj: {
          method: "fetchFeedbackDetails",
          component: "EmailReply",
          fileName: "EmailReply.tsx",
          feddbackData: feddbackData,
        },
      });
      if (feddbackData && feddbackData.Items && feddbackData.Items.length > 0) {
        setFeedbackDetails(feddbackData.Items[0]);
        setStatusValue(
          getStatusRenderLabel(feddbackData.Items[0]?.status) || "new"
        );
        setselectedPriority(
          feddbackData.Items[0]?.bugPriority.toLowerCase() || "medium"
        );
      }
    } catch (error) {
      setLoader(false);
      props.snackbarShowMessage(
        "Error in fetching feedbackData in Email Reply",
        "error"
      );
      appLogger.info({
        infoObj: {
          method: "fetchFeedbackDetails",
          component: "EmailReply",
          fileName: "EmailReply.tsx",
          error: error,
        },
      });
    }
  };
  useEffect(() => {
    fetchFeedbackDetails();
    fetchProductDetails();
  }, []);
  const PriorityDropDownItems = (props: any) => {
    return (
      <Typography
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <img className="cuvo_priority_icons" src={props.image} />
        <Typography sx={{ fontSize: 13, pl: 1 }}>{props.type}</Typography>
      </Typography>
    );
  };
  const goBackToTicketPage = (type: string) => {
    appLogger.info({
      infoObj: {
        method: "goBackToTicketPage",
        component: "ticketreply",
        fileName: "reply.tsx",
        type: type,
      },
    });
    const stateObj = {
      pageType: type,
      insight: "",
      keyName: "",
      keyWordType: "",
    };
    navigate("/feedback", { state: stateObj });
  };
  const handlePriorityChange = (event: any) => {
    setselectedPriority(event.target.value);
    const putObj = {
      "id": feedbackDetails.id,
      "priority": event.target.value,
    };
    putPriorityUpdate(putObj);
  };
  const putPriorityUpdate = (putData: any) => {
    setLoader(true);
    setPriotyUpdateLoader(true);
    Http.put({
      url: `/api/v2/userFeedback`,
      body: {
        ...putData,
      },
      state: userInfo,
    })
      .then((response: any) => {
        setLoader(false);
        setPriotyUpdateLoader(false);

        if (response && response.message === "ok") {
          props.snackbarShowMessage(
            "Data updated successfully",
            "success",
            3000
          );
        } else {
          props.snackbarShowMessage("Priority assigned failed", "error", 3000);
        }
      })
      .catch((error: any) => {
        setLoader(false);
        setPriotyUpdateLoader(false);
        props.snackbarShowMessage(error.message, "error");
      });
  };
  const updateSubject = (val: any) => {
    setSubject(val);
  };
  const updateStatus = (val: any) => {
    setStatusValue(val);
  };
  const renderIndex = (label: any) => {
    const data = [...new Set(messages)];
    return data.indexOf(label);
  };
  let userEnabledFeatures: any = localStorage.getItem("userenabledFeatures");
  if (userEnabledFeatures) {
    userEnabledFeatures = JSON.parse(userEnabledFeatures);
  }
  const fetchProductDetails = () => {
    if (productDetails) {
      setLoader(true);
      Http.get({
        url: `/api/v2/products/${productDetails.productId}/${productDetails.productVersion}`,
        state: userInfo,
      })
        .then((response: any) => {
          setLoader(false);
          if (response && response.products && response.products.length > 0) {
            const details = response.products[0];
            if (details && Object.keys(details.emailConfig).length > 0) {
              if (
                pagetype == getpageTypeEmail(pagetype) &&
                Object.keys(details.emailConfig[getpageTypeForEmail(pagetype)])
                  .length > 0 &&
                Object.keys(
                  details.emailConfig[getpageTypeForEmail(pagetype)][
                    "connectionDetails"
                  ]
                ).length > 0
              ) {
                const datass =
                  details.emailConfig[getpageTypeForEmail(pagetype)][
                    "connectionDetails"
                  ];
                if (
                  datass &&
                  datass.emailAddress != "" &&
                  datass.emailAddress != undefined
                ) {
                  setEnablingEmailTab(true);
                }
              }
            }
          }
          // setFeedbackAgentSettingsFetched(true);
        })
        .catch((error: any) => {
          appLogger.error({
            errObj: {
              method: "useEffect",
              component: "add-products",
              fileName: "index.tsx",
              err: error,
            },
          });
          props.snackbarShowMessage("products fetch error", "error", 3000);
        });
    } else {
      // setProductParams({ products: [newProd] });
    }
  };
  const renderSubject = () => {
    if (
      feedbackDetails &&
      productDetails?.userId &&
      productDetails?.isEmailPresent &&
      enableMailReply &&
      userEnabledFeatures?.enableMailReply
    ) {
      return (
        "- " + (subjectVal || "Conversation with " + feedbackDetails?.userId)
      );
    }
  };
  const getSplittedFeedbackId = (rowid: any) => {
    const segments = rowid?.split("-");
    const lastSegment = segments?.pop();
    return lastSegment;
  };
  return (
    <div className={loader ? "feedback-wrap loader" : "feedback-wrap"}>
      <Grid
        container
        spacing={2}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          borderBottom: "1px solid",
          borderColor: "rgba(0, 0, 0, 0.12)",
          background: "none",
          padding: "10px 45px 10px 45px",
          // borderRadius: "8px 8px 0 0",
        }}
      >
        {/* First section with 6 columns */}
        <Grid
          item
          xs={12}
          md={8}
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <IconButton
            sx={{
              paddingTop: "8px",
            }}
            onClick={() => goBackToTicketPage(getpageType(pagetype))}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
            >
              <g opacity="0.5" clip-path="url(#clip0_1205_1601)">
                <path
                  d="M15.9782 7.30663C15.9086 7.29535 15.8383 7.29014 15.7678 7.29105H3.77466L4.03617 7.16942C4.29179 7.04843 4.52434 6.88377 4.7234 6.68288L8.08659 3.3197C8.52952 2.89687 8.60395 2.21667 8.26296 1.70805C7.86609 1.16605 7.105 1.04837 6.56297 1.44524C6.51918 1.47732 6.47756 1.51229 6.43844 1.54992L0.35674 7.63163C-0.118546 8.10638 -0.118964 8.87651 0.355789 9.3518C0.356093 9.3521 0.356436 9.35244 0.35674 9.35275L6.43844 15.4345C6.91411 15.9088 7.68424 15.9077 8.15862 15.4321C8.19594 15.3946 8.2308 15.3548 8.26296 15.3128C8.60395 14.8042 8.52952 14.124 8.08659 13.7012L4.72949 10.3319C4.55103 10.1533 4.34584 10.0035 4.12132 9.88794L3.75641 9.72373H15.7009C16.3222 9.74681 16.8674 9.31276 16.9841 8.70201C17.0917 8.03891 16.6413 7.41421 15.9782 7.30663Z"
                  fill="black"
                />
              </g>
              <defs>
                <clipPath id="clip0_1205_1601">
                  <rect width="17" height="17" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </IconButton>
          {/* <span style={{ fontSize: "13px", color: "#3b3939" }}>
            Correlation / Ticket Categories /{" "}
          </span> */}
          {/* <span> */}
          {/* <span style={{ fontSize: "13px", fontWeight: 500 }}>
              Ticket:&nbsp;
            </span> */}
          {/* <span style={{ paddingRight: "5px" }}>
            <img
              className="cuvo_priority_icons"
              style={{
                width: "20px",
                height: "20px",
                display: "flex",
              }}
              src={images.ticketicon}
            />
          </span> */}
          {feedbackDetails?.refId && feedbackDetails?.refId.length > 0
            ? feedbackDetails.refId
            : getSplittedFeedbackId(feedbackDetails?.id)}
          <span
            style={{
              fontSize: "13px",
              fontWeight: "bold",
              color: "#3b3939",
              marginLeft: "6px",
            }}
          >
            {renderSubject()}
          </span>{" "}
          {/* </span> */}
        </Grid>
        {/* Second section with 6 columns */}
        <Grid item xs={12} md={4}>
          {/* Second section divided into three sub-sections */}
          <Grid container spacing={2} sx={{ justifyContent: "flex-end" }}>
            {/* First sub-section with 3 columns */}
            <Grid item xs={12} sm={4}>
              {feedbackDetails?.feedbackType != "FEEDBACK" &&
                feedbackDetails?.feedbackType != "FEATURE_REQUEST" &&
                selectedPriority != "" && (
                  <Box>
                    <FormControl className="custom-select" fullWidth>
                      <Select
                        onChange={(event) => handlePriorityChange(event)}
                        value={selectedPriority}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                      >
                        <MenuItem key="1" value="high">
                          {
                            <PriorityDropDownItems
                              image={images.highpriority}
                              type="High"
                            />
                          }
                        </MenuItem>
                        <MenuItem key="2" value="medium">
                          {
                            <PriorityDropDownItems
                              image={images.mediumpriority}
                              type="Medium"
                            />
                          }
                        </MenuItem>
                        <MenuItem key="3" value="low">
                          {
                            <PriorityDropDownItems
                              image={images.lowpriority}
                              type="Low"
                            />
                          }
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                )}
            </Grid>
            {/* Second sub-section with 3 columns */}
            <Grid item xs={12} sm={4}>
              <Box>
                {StatusValue && (
                  <Chip
                    label={StatusValue}
                    // label={feedbackDetails?.status || "open"}
                    sx={{
                      textTransform: "inherit",
                      ...renderStatusColorCss(StatusValue),
                      // ...renderStatusColorCss(feedbackDetails?.status || "open"),
                    }}
                  />
                )}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {/* {!loader && ( */}
      <Box>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={value} onChange={handleChange} aria-label="dashboards">
            {productDetails?.userId &&
              productDetails?.isEmailPresent &&
              // EnablingEmailTab &&
              enableMailReply &&
              userEnabledFeatures?.enableMailReply && (
                <Tab label="Email" {...a11yProps(0, "Email")} />
              )}
            <Tab label="Details" {...a11yProps(1, "Details")} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={renderIndex("Email")} className="">
          <EmailReply
            subjectVal={subjectVal}
            feedbackDetails={feedbackDetails}
            updateSubject={updateSubject}
            updateStatus={updateStatus}
            pagetype={pagetype}
          />
        </TabPanel>
        {!loader && (
          <TabPanel value={value} index={renderIndex("Details")} className="">
            <TicketDetails
              feedbackDetails={feedbackDetails}
              updateSubject={updateSubject}
              selectedPriority={selectedPriority}
            />
          </TabPanel>
        )}
      </Box>
      {/* )} */}
    </div>
  );
};

export default withSnackbar(TicketsDetailsReply);
